



















































































































































































































import { ScreenText } from '@/lang/ScreenText';
import formsStore from '@/store/modules/forms/formsStore';
import APP_CONST from '@/constants/AppConst';
import APP_UTILITIES from '@/utilities/commonFunctions';
import { Component, Mixins, PropSync } from 'vue-property-decorator';
import UIkit from 'uikit';
import { logoutResponseObj } from '@/services/userService/users-api';
import commonEntry from '@/store/modules/commonEntry';
import applicationStore from '@/store/modules/applications/applicationStore';
import AccountSettings from '@/mixins/accountSettings.mixin';
import CartLink from '@/components/familyPortal/checkout/cart/CartLink.vue';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import cartStore from '@/store/modules/checkout/cart/module';
import { getInstance } from '@/auth';

@Component({
  components: {
    CartLink
  }
})
export default class HeaderComponent extends Mixins(AccountSettings, DeviceWidthCheckerMixin) {
  @PropSync('offcanvasVisible', { type: Boolean, default: false }) offcanvasVisibleSync!: boolean;
  public headerDropDownActive: boolean = false;
  public isAuthTokenSet: boolean = false;
  public tooltipText: string = '';
  public styleObj = {};
  public isActive: boolean = false;
  public siteSelectedIds: any = [];
  public APP_ROUTES = APP_CONST.APP_ROUTES;
  public APP_CONST = APP_CONST;
  userLoggedIn = false;
  readonly screenText = new ScreenText();

  /* istanbul ignore next */
  get currentRoute() {
    const path = this.$route && this.$route.path;
    return path;
  }

  /* istanbul ignore next */
  get firstNameInitial() {
    return this.firstName.charAt(0) || '';
  }

  /* istanbul ignore next */
  get disableDocument() {
    return applicationStore.isDisableDocument || APP_UTILITIES.getCookie('disableDocument');
  }

  /* istanbul ignore next */
  get firstName() {
    return commonEntry.savedUserName || '';
  }
  /* istanbul ignore next */
  get siteList() {
    return applicationStore.sitesList;
  }
  /* istanbul ignore next */
  get disabledButton() {
    let selected: boolean = false;
    applicationStore.siteList && applicationStore.siteList.forEach(element => {
      if (element.selected) {
        selected = element.selected;
        return selected;
      }
    });
    return selected;
  }

  /* istanbul ignore next */
  get isPartTwoSubmission() {
    return applicationStore.isOutstandingItems || APP_UTILITIES.getCookie('outStandingItems');
  }

  get signInButtonText(): string {
    return this.screenText.getScreenText('BTN_SIGN_IN');
  }

  beforeMount() {
    const { isAuthenticated } = getInstance();
    this.userLoggedIn = isAuthenticated;
  }

  /* istanbul ignore next */
  isShowFormBreadCrum() {
    if (APP_UTILITIES.getCookie('outStandingItemIndex') || APP_UTILITIES.getCookie('outStandingItems')) {
      const currentIndex: any = JSON.parse(APP_UTILITIES.getCookie('outStandingItemIndex') || '');
      const application: any = JSON.parse(APP_UTILITIES.getCookie('outStandingItems') || '');
      if (application.length && application[currentIndex].isFormSubmited) {
        return false;
      }
      else {
        return true;
      }
    }
    return true;
  }

  /* istanbul ignore next */
  isShowDocBreadCrum() {
    if (APP_UTILITIES.getCookie('outStandingItemIndex') || APP_UTILITIES.getCookie('outStandingItems')) {
      const currentIndex: any = JSON.parse(APP_UTILITIES.getCookie('outStandingItemIndex') || '');
      const application: any = JSON.parse(APP_UTILITIES.getCookie('outStandingItems') || '');
      if (application.length && application[currentIndex].isDocumentSubmitted) {
        return false;
      }
      else {
        return true;
      }
    }
    return true;
  }

  async logout() {
    UIkit.notification.closeAll();
    const { logout } = getInstance();
    await logout();
    APP_UTILITIES.segmentTrackEvent('User Logged Out');
    localStorage.setItem('slug', APP_UTILITIES.accountSlug);
    sessionStorage.removeItem('user_role');
    applicationStore.mutateSiteList([]);
    localStorage.setItem('selectedGuid', '');
    this.removeCookie();
    commonEntry.reset();
    cartStore.RESET_CART();
  }

  removeCookie() {
    APP_UTILITIES.removeCookies();
    APP_UTILITIES.removeSpecificCookie('applicationData');
    APP_UTILITIES.removeSpecificCookie('user_role');
    APP_UTILITIES.removeSpecificCookie('user_id');
    this.$router && this.$router.push(APP_CONST.APP_ROUTES.LOGIN);
    localStorage.removeItem('all_selected_sites');
  }

  getCookie(name: string) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) == 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }

  setCookie(name: string, value: any, days: any) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }

  public visitRoute(route: string) {
    if (this.isPartTwoSubmission) {
      this.$route.path == route
        ? ''
        : this.$router.push(route).catch(() => { });
    }
    else {
      if (this.routeAvailability(route)) {
        this.$route.path == route
          ? ''
          : this.$router.push(route).catch(() => { });
      }
      this.isActive = false;
      document.body.classList.remove('body_class');
    }
  }

  protected routeAvailability(route: string) {
    const matched = this.$router && this.$router.getMatchedComponents(route);
    if (matched && matched.length > 0) {
      return true;
    }
    return false;
  }

  navigateToFAQ() {
    window.open(APP_CONST.FAQ_FAMILY, '_blank');
  }

  showTooltip(val: string, event: any) {
    this.tooltipText = val;
    const boundBox = event && event.target && event.target.getBoundingClientRect();
    const coordX = boundBox.left;
    const coordY = boundBox.top;
    this.styleObj = {
      top: (coordY + 30).toString() + 'px',
      left: (coordX - 60).toString() + 'px'
    };
  }

  hideTooltip() {
    this.tooltipText = '';
  }

  toggleMenu() {
    this.isActive = !this.isActive;
    const width = document.documentElement.clientWidth;
    if (this.isActive && width < 992) {
      document.body.classList.add('body_class');
    }
    else {
      document.body.classList.remove('body_class');
    }
  }
}
